module.exports = __webpack_public_path__ + "static/media/forgotpassword.b1e84783.gif";